// ---------------------------
// detect window size
export function getWindowSize(breakpointValue) {
  const breakpoint = breakpointValue;
  return $(globalThis).width() >= breakpoint;
}

// ---------------------------
// search feature fixes
export function headerSearchBarFix(searchPlaceholder) {
  const showMobileSearch = false;
  const mobileTrigger = getWindowSize(800);

  const $searchBox = $('.header .searchBox');
  $searchBox.find('.searchBoxSubmit .inputFieldSubmit:first').attr('tabindex', '-1');
  $searchBox.find('input').val('').attr('placeholder', searchPlaceholder);

  if (showMobileSearch) {
    $searchBox.addClass('mobile-enabled');

    if (!mobileTrigger) {
      $searchBox.attr('tabindex', '0');
    }
  }
}

// ---------------------------
// dynamic margin
export function updateContentMargin() {
  function applyMargin() {
    const headerHeight = $('header').outerHeight();

    const mq = globalThis.matchMedia('(max-width: 890px)');
    const additionalValue = mq.matches ? 30 : 40;

    const content = $('.content');
    const isHomepage = $('body').hasClass('homepage');

    content.css(
      'margin-top',
      isHomepage ? `${headerHeight}px` : `${headerHeight + additionalValue}px`,
    );
  }
  applyMargin();

  $(globalThis).on('resize', applyMargin);

  $(globalThis).on('scroll', function () {
    if ($(this).scrollTop() === 0) {
      setTimeout(applyMargin, 300);
    }
  });
}

// ---------------------------
// lineup alignment
export function modifyFeatureLineup() {
  const lineups = $('.featureLineupContainer');
  if (!lineups.length) return;

  lineups.each((_, el) => {
    const $lineup = $(el);
    const containerWidth = $lineup.width();
    const buttonContainer = $lineup.find('.featureLineup-buttons.subContainer');
    const icons = buttonContainer.find('.featureLineup-social');
    const cta = buttonContainer.find('.featureLineup-buynow');

    if (!icons.children().length) {
      icons.remove();
      buttonContainer.addClass('no-social');
      return;
    }

    const totalWidth = icons.outerWidth(true) + cta.outerWidth(true);

    if (totalWidth > containerWidth) {
      buttonContainer.addClass('column');
    }
  });
}

export function updateCustomSignup() {
  const $signup = $('.footer .emailSignup ');

  $signup.find('.emailInputSubmit a').text('Sign Up');

  $signup.find('input').val('').attr('placeholder', 'Email Address');
}
